
import { computed, ref } from 'vue'
import { useStore } from 'vuex';
import { availableFinishes } from "VueInterfaces/ProductFamilyInterface";
import slugify from "slugify";
export default {
	props: {
		displayName: String,
		primaryImageUrl: {
			type: String,
			default: ''
		},
		availability: String,
		link: String,
		translations: {
			type: Object,
			default: {},
		},
		alternateFinishes: {
			type: Array,
			default: () => [] as availableFinishes[]
		}
	},
    setup(props) {
	    const store = useStore();
	    const avblActive = ref('active');
		const fallbackImage = ref('https://images.weiserlock.com/is/image/Weiser/imagenotavailable2?wid=400');
        const productStatus = computed(() => {
            return props.availability === `Active` ? 'category-browse__product' : 'category-browse__product category-browse__product--unavailable';
        });

		const finishImagePath = computed(() => {
			return props.alternateFinishes.length ? props.alternateFinishes.filter(item => item.slug === store.state?.selectedFinish?.slug)[0]?.primaryImageUrl : props.primaryImageUrl;
		});

		const linkWithoutFinish = computed(() => {
			return props.link && props.link.includes('&finish') ? props.link.split('&finish')[0] : props.link;
		});

		const notAvailableInFinish = computed(() => {
			return props.alternateFinishes.length && !props.alternateFinishes.some((finish) => finish.slug === store.state?.selectedFinish?.slug);
		});

		const firstFinishInArray = computed(() => {
			return props.alternateFinishes.length ?  props.alternateFinishes[0]?.primaryImageUrl : '';
		});

	    const availabilitySlug = computed(() => {
		    return props.availability
			    ? slugify(props.availability, {
				    lower: true, // convert to lower case, defaults to `false`
				    strict: true, // strip special characters except replacement, defaults to `false`
				    remove: /[*+~.()'"!:@]/g,
			    })
			    : '';
	    });

        return {
            productStatus,
	        store,
	        finishImagePath,
	        fallbackImage,
	        linkWithoutFinish,
	        firstFinishInArray,
	        notAvailableInFinish,
	        avblActive,
	        availabilitySlug
        }
    },
}
